// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as TerminationStatus from "../entity/TerminationStatus.bs.js";
import * as DriverActiveStatus from "../../partner/entity/DriverActiveStatus.bs.js";

function terminationRecordDecoder(json) {
  return {
          terminationAdmin: Json_decode.field("termination_admin", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          terminationDescription: Json_decode.field("termination_description", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          terminationDuration: Json_decode.field("termination_duration", Json_decode.string, json),
          terminationEndTime: Json_decode.field("termination_end_time", Json_decode.string, json),
          terminationStartTime: Json_decode.field("termination_start_time", Json_decode.string, json),
          comment: Json_decode.optional((function (param) {
                  return Json_decode.field("termination_comment", Json_decode.string, param);
                }), json),
          terminationStatus: TerminationStatus.fromString(Json_decode.field("termination_status", Json_decode.string, json))
        };
}

function terminationInfoDecoder(json) {
  return {
          activeStatus: DriverActiveStatus.fromString(Json_decode.field("active_status", Json_decode.string, json)),
          driverTerminationHistory: Json_decode.field("driver_termination_history", (function (param) {
                  return Json_decode.list(terminationRecordDecoder, param);
                }), json)
        };
}

function builder(json) {
  return Json_decode.field("termination_info", terminationInfoDecoder, json);
}

var TerminationInfo = {
  terminationRecordDecoder: terminationRecordDecoder,
  terminationInfoDecoder: terminationInfoDecoder,
  builder: builder
};

function terminationReasonDecoder(reasonJson) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, reasonJson),
          description: Json_decode.field("description", Json_decode.string, reasonJson)
        };
}

function builder$1(json) {
  return Json_decode.field("result", (function (param) {
                return Json_decode.list(terminationReasonDecoder, param);
              }), json);
}

var TerminationReasons = {
  terminationReasonDecoder: terminationReasonDecoder,
  builder: builder$1
};

export {
  TerminationInfo ,
  TerminationReasons ,
  
}
/* No side effect */
